module.exports = __webpack_public_path__ + "static/assets/42523926059b05308099a438f72c94b7.png";